var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 512",
    style: {
      enableBackground: "new 0 0 448 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6,297.4l308,208.1c25,16.9,63.3,0.5,63.3-41.3V48.1c0-37.5-35.6-60.1-63.3-41.3l-308,208 C49.2,233.3,49.1,278.9,76.6,297.4L76.6,297.4z M90.8,242.3l308-208c9.3-6.1,21.2,1.2,21.2,13.8v416.1c0,16.3-14.3,18.4-21.1,13.8 l-308-208.1C81.7,263.7,81.7,248.5,90.8,242.3L90.8,242.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5,504.5H35c-15.2,0-27.5-12.3-27.5-27.5V39.5C7.5,24.3,19.8,12,35,12h9.5C59.7,12,72,24.3,72,39.5V477 C72,492.2,59.7,504.5,44.5,504.5z M35,32c-4.1,0-7.5,3.4-7.5,7.5V477c0,4.1,3.4,7.5,7.5,7.5h9.5c4.1,0,7.5-3.4,7.5-7.5V39.5 c0-4.1-3.4-7.5-7.5-7.5H35z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.aec5fa8b81f2aae6c665631bb480c2f2.svg";
export { ForwardRef as ReactComponent };